import { applyTranslation, blocks, translationUnits, type Blocks, type KeepOptions, type TranslationRow } from '@w/content-blocks'

/** The title is a page column, not a block: it joins translation as one more unit of its page under this id. */
export const pageTitleUnitId = 'page-title'

/** Shaped like a cloze tip unit (translation-units.ts visitUnits): one paragraph holding the title text. */
function titleBlocks(title: string): Blocks {
  return [{ id: pageTitleUnitId, type: 'p', children: [{ id: `${pageTitleUnitId}:text`, type: 'text', text: title }] }]
}

/** A choice question that plays audio (in its prompt, or right before it) asks which word the learner hears: a translated
 * option would give the answer away, so its options stay as authored (page-translation.spec.md, listening options). */
export const keepListeningOptions: KeepOptions = (question, previous) =>
  previous?.type === 'audio' || (question.question ?? []).some(block => block.type === 'audio')

/** HTML translation units of a page: its title, then its body, so extraction and maintenance key them alike. */
export function pageTranslationUnits(page: { title: string; children: Blocks }) {
  return translationUnits([...titleBlocks(page.title), ...page.children], { keepOptions: keepListeningOptions })
}

/** The title as the translated view shows it; the authored title when no usable row exists. */
export function translatedPageTitle(title: string, rows: TranslationRow[]): string {
  if (!rows.some(row => row.blockId === pageTitleUnitId)) return title
  return blocks.serialize(applyTranslation(titleBlocks(title), rows), { plainText: true })
}
